import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ProjectType, ProjectTypesData} from "@core/services/backend/common/interface/project-types";
import {ProjectTypesApi} from "@core/services/backend/common/api/project-types.api";

@Injectable()
export class ProjectTypesService extends ProjectTypesData {
    constructor(private api: ProjectTypesApi) {
        super();
    }

    list(search: string, pageNumber: number, pageSize: number, orderBy: string): Observable<any[]> {
        return this.api.list(search, pageNumber, pageSize, orderBy);
    }

    get(id: number): Observable<ProjectType> {
        return this.api.get(id);
    }

    create(projectType: any): Observable<ProjectType> {
        return this.api.add(projectType);
    }

    update(projectType: any): Observable<ProjectType> {
        return this.api.update(projectType);
    }

    delete(projectType: any): Observable<ProjectType> {
        return this.api.delete(projectType);
    }
}

